import axios from "axios";

const apiUrl = process.env.REACT_APP_API_URL;

export const api = axios.create({
  baseURL: `${apiUrl}/api`, 
  withCredentials: true, // cookies
  headers: {
    "X-Client-Host": window.location.origin
  }
});